import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

/**
 * Opens the Add-tax modal. The panel reads the current tax config from Redux and commits the three tax fields
 * (label / rate / mode) on Save, so no props are needed here.
 */
export const openTicketingAddTaxModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.TICKETING_ADD_TAX_MODAL,
      panelProps: {},
    })
  );
};
